module.exports = __webpack_public_path__ + "static/img/06023B_2_3_R_20180512_LC.c61bfc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/06023B_2_3_R_20180512_LC.png
// module id = 5xdN
// module chunks = 0